export var CALCULATOR_FORMS;
(function (CALCULATOR_FORMS) {
  CALCULATOR_FORMS["PAYMENT_ANALYZER"] = "paymentAnalyzer";
  CALCULATOR_FORMS["MAXIMUM_MORTGAGE"] = "maximumMortgage";
  CALCULATOR_FORMS["MINIMUM_INCOME"] = "minimumIncome";
  CALCULATOR_FORMS["SCENARIO_BUILDER"] = "scenarioBuilder";
  CALCULATOR_FORMS["PREPAYMENT_ANALYZER"] = "prepaymentAnalyzer";
  CALCULATOR_FORMS["MORTGAGE_ISOLATOR"] = "mortgageIsolator";
  CALCULATOR_FORMS["MORTGAGE_ANALYZER"] = "mortgageAnalyzer";
  CALCULATOR_FORMS["AMORTIZATION_SCHEDULE"] = "amortizationSchedule";
})(CALCULATOR_FORMS || (CALCULATOR_FORMS = {}));